module.exports = __webpack_public_path__ + "assets/img/paper-cabinet.9b01db3e.svg";